import { Component } from '@angular/core';

@Component({
    selector: 'op-exchange-currency-content',
    templateUrl: './exchange-currency-content.component.html'
})
export class ExchangeCurrencyContentComponent {
}
